import React, { useState } from 'react';
import { FaUserCircle, FaMapMarkerAlt, FaFileUpload } from 'react-icons/fa'; // Better icons
import { ImSpinner9 } from 'react-icons/im'; // Loading spinner
import {useNavigate} from "react-router-dom"; 
import {useLocation} from "react-router-dom"; 
import AccessDeniedPage from "../pages/AccessDeniedPage"; 
import Loading from "../pages/Loading"; 
import Footer from "./Footer"; 
import SmartsupChat from "./SmartsupChat"; 

const KYCVerification = () => {
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState('');
  const [formData, setFormData] = useState({
    fullName: '',
    dob: '',
    address: '',
    city: '',
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate(); 
  const signupLocation = useLocation(); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDocumentSelection = (e) => {
    setSelectedDocument(e.target.value);
  };

  const validateStep1 = () => {
    const errors = {};
    if (!formData.fullName) errors.fullName = 'Full Name is required';
    if (!formData.dob) errors.dob = 'Date of Birth is required';
    return errors;
  };

  const validateStep2 = () => {
    const errors = {};
    if (!formData.address) errors.address = 'Address is required';
    if (!formData.city) errors.city = 'City is required';
    return errors;
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    if (step === 1) {
      const step1Errors = validateStep1();
      if (Object.keys(step1Errors).length > 0) {
        setErrors(step1Errors);
        isValid = false;
      }
    } else if (step === 2) {
      const step2Errors = validateStep2();
      if (Object.keys(step2Errors).length > 0) {
        setErrors(step2Errors);
        isValid = false;
      }
    }

    if (isValid && step === 3) {
      setIsSubmitting(true);
      // Simulate a delay for submission
      setTimeout(() => {
        setIsSubmitting(false);
		  navigate("/login"); 
      }, 5000);
    } else if (isValid && step < 3) {
      handleNext();
    }
  };
 if(isSubmitting){
	return <Loading />
 }

  return localStorage.getItem("verified")==="yes" ? (
	  <div>
    <div className="relative max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-lg overflow-hidden">
      
      <div className="mb-6">
        <h2 className="text-2xl font-bold mb-2 text-blue-600">KYC Verification</h2>
        <p className="text-gray-600">Complete the following steps to verify your identity.</p>
      </div>

      <div className="relative mb-6">
        <div className="flex justify-between mb-4">
          <div className={`w-1/3 h-1 ${step >= 1 ? 'bg-blue-600' : 'bg-gray-300'} transition-all duration-300`} />
          <div className={`w-1/3 h-1 ${step >= 2 ? 'bg-blue-600' : 'bg-gray-300'} transition-all duration-300`} />
          <div className={`w-1/3 h-1 ${step >= 3 ? 'bg-blue-600' : 'bg-gray-300'} transition-all duration-300`} />
        </div>
        <div className="absolute top-0 inset-x-0 flex justify-between text-xs text-gray-600">
          <p className={`${step >= 1 ? 'text-blue-600' : ''}`}>Personal Info</p>
          <p className={`${step >= 2 ? 'text-blue-600' : ''}`}>Address</p>
          <p className={`${step >= 3 ? 'text-blue-600' : ''}`}>Documents</p>
        </div>
      </div>

      {step === 1 && (
        <div className="animate-fadeIn mt-6">
          <h3 className="text-xl font-semibold mb-4 flex items-center">
            <FaUserCircle className="mr-2 text-blue-600 text-2xl" />
            Personal Information
          </h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className={`w-full p-2 border ${errors.fullName ? 'border-red-500' : 'border-gray-300'} rounded-lg transition-all duration-300 focus:border-blue-500`}
              />
              {errors.fullName && <p className="text-red-500 text-xs mt-1">{errors.fullName}</p>}
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Date of Birth</label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                className={`w-full p-2 border ${errors.dob ? 'border-red-500' : 'border-gray-300'} rounded-lg transition-all duration-300 focus:border-blue-500`}
              />
              {errors.dob && <p className="text-red-500 text-xs mt-1">{errors.dob}</p>}
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-700 transition-transform transform hover:scale-105"
              >
                Next
              </button>
            </div>
          </form>
        </div>
      )}

      {step === 2 && (
        <div className="animate-fadeIn mt-6">
          <h3 className="text-xl font-semibold mb-4 flex items-center">
            <FaMapMarkerAlt className="mr-2 text-blue-600 text-2xl" />
            Address Information
          </h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className={`w-full p-2 border ${errors.address ? 'border-red-500' : 'border-gray-300'} rounded-lg transition-all duration-300 focus:border-blue-500`}
              />
              {errors.address && <p className="text-red-500 text-xs mt-1">{errors.address}</p>}
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className={`w-full p-2 border ${errors.city ? 'border-red-500' : 'border-gray-300'} rounded-lg transition-all duration-300 focus:border-blue-500`}
              />
              {errors.city && <p className="text-red-500 text-xs mt-1">{errors.city}</p>}
            </div>
            <div className="flex justify-between">
              <button
                type="button"
                onClick={handleBack}
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg shadow-lg hover:bg-gray-400 transition-transform transform hover:scale-105"
              >
                Back
              </button>
              <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-700 transition-transform transform hover:scale-105"
              >
                Next
              </button>
            </div>
          </form>
        </div>
      )}

      {step === 3 && (
        <div className="animate-fadeIn mt-6">
          <h3 className="text-xl font-semibold mb-4 flex items-center">
            <FaFileUpload className="mr-2 text-blue-600 text-2xl" />
            Upload Documents
          </h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">Select Document Type</label>
              <select
                value={selectedDocument}
                onChange={handleDocumentSelection}
                className="w-full p-2 border border-gray-300 rounded-lg transition-all duration-300 focus:border-blue-500"
                required
              >
                <option value="">Select a document</option>
                <option value="driving_license">Driving License</option>
                <option value="national_id">National Identity Card</option>
                <option value="birth_certificate">Birth Certificate</option>
                <option value="other">Other</option>
              </select>
            </div>
            {selectedDocument && (
              <div className="mb-4">
                <label className="block text-gray-700">Upload Document</label>
                <input
                  type="file"
                  className="w-full p-2 border border-gray-300 rounded-lg transition-all duration-300"
                  required
                />
              </div>
            )}
            <div className="flex justify-between">
              <button
                type="button"
                onClick={handleBack}
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg shadow-lg hover:bg-gray-400 transition-transform transform hover:scale-105"
              >
                Back
              </button>
              <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-700 transition-transform transform hover:scale-105"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      ) }
		 <SmartsupChat />
    </div>
		<Footer />
  </div>
  ): (<AccessDeniedPage />)
};

export default KYCVerification;

